<template>
	<el-drawer title="演出结款信息" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
		@close="close">
		<div class="drawer-content" v-loading="dataLoading">
			<template v-if="data">
				<div class="group">
					<div class="page-group-title"><span>收款信息</span></div>
					<table class="info-table MT20" width="100%" v-if="data.receivablesInfo">
						<tr>
							<th>收款联系人姓名</th>
							<td>{{data.receivablesInfo.userName}}</td>
							<th>收款联系人手机</th>
							<td>{{data.receivablesInfo.userTelephone}}</td>
						</tr>
						<tr>
							<th>收款联系人邮箱</th>
							<td>{{data.receivablesInfo.userEmail}}</td>
							<th>通讯地址</th>
							<td>{{data.receivablesInfo.address}}</td>
						</tr>
						<tr>
							<th>银行</th>
							<td>{{data.receivablesInfo.bankName}}</td>
							<th>开户网点</th>
							<td>{{data.receivablesInfo.bankAddress}}</td>
						</tr>
						<tr>
							<th>卡号</th>
							<td>{{data.receivablesInfo.bankCardId}}</td>
							<th>账户名</th>
							<td>{{data.receivablesInfo.bankAccount}}</td>
						</tr>
						<tr>
							<th>账户性质</th>
							<td>{{data.receivablesInfo.accountType == 1 ? '企业' : '个人'}}</td>
							<th>合同编号</th>
							<td>{{data.receivablesInfo.contractSn}}</td>
						</tr>
					</table>
					<div v-else class="color-danger">
						<span class="el-icon-warning"></span> 结款方的演出收款信息待完善
					</div>
				</div>
				<div class="group MT20">
					<div class="page-group-title"><span>基本信息</span></div>
					<table class="info-table MT20" width="100%" v-if="data.baseInfo">
						<tr v-for="(item, index) in data.baseInfo" :key="index">
							<th>{{item.name}}</th>
							<td>{{item.value}}</td>
						</tr>
					</table>
				</div>
				<div class="group MT20">
					<div class="page-group-title"><span>结算参考</span></div>
					<div v-if="data.referenceInfo">
						<span class="color-danger">预计结款</span> <span> = </span> 收入合计-扣款合计 <span
							class="el-icon-right"></span>
						{{data.referenceInfo.incomeTotalAmount}}-{{data.referenceInfo.deductionTotalAmount}}<span
							class="color-danger"> = {{data.referenceInfo.expectedTotalAmount}}</span>
					</div>
					
					<table class="info-table MT20" width="100%">
						<tr>
							<th>秀动收入相关</th>
							<th>金额</th>
							<th>备注</th>
						</tr>
						<tr v-for="(item, index) in data.referenceInfo.totalList" :key="index">
							<td>{{item.name}}</td>
							<td>{{item.value}}</td>
							<td>{{item.tips}}</td>
						</tr>
					</table>					
					<table class="info-table MT20" width="100%">
						<tr>
							<th>B类收入相关</th>
							<th>金额</th>
							<th>备注</th>
						</tr>
						<tr v-for="(item, index) in data.referenceInfo.incomeList" :key="index">
							<td>{{item.name}}</td>
							<td>{{item.value}}</td>
							<td>{{item.tips}}</td>
						</tr>
					</table>
					
					<table class="info-table MT20" width="100%">
						<tr>
							<th>结款扣款项</th>
							<th>金额</th>
							<th>备注</th>
						</tr>
						<tr v-for="(item, index) in data.referenceInfo.deductionList" :key="index">
							<td>{{item.name}}</td>
							<td>{{item.value}}</td>
							<td>{{item.tips}}</td>
						</tr>
					</table>				
				</div>
				<div class="group MT20">
					<div class="page-group-title"><span>结算单列表</span></div>
					<table class="info-table MT20" width="100%">
						<tr>
							<th>结算单ID</th>
							<th>结算场次</th>
							<th>结算单状态</th>
							<th>结算单时间</th>
							<th>金额</th>
						</tr>
						<tr v-for="(item, index) in data.settlementDocInfo" :key="index">
							<td>{{item.id}}</td>
							<td style="width: 200px;">{{item.settlementSession}}</td>
							<td>{{item.settlementStatus}}</td>
							<td>
								<p>申请打款：{{item.createTime}}</p>
								<p>实际打款：{{item.playTime}}</p>
							</td>
							<td>
								<p>结款金额：{{item.settlementAmount}}</p>
								<p>实际打款：{{item.playAmount}}</p>
							</td>
						</tr>
					</table>
				</div>
				<div v-if="data.referenceInfo.technicalServiceFeeList && data.referenceInfo.technicalServiceFeeList.length > 0" class="group MT20">
					<div class="page-group-title"><span>额外技术服务费明细（总金额{{data.referenceInfo.technicalServiceFeeAmountStr}}）</span></div>
					<table class="info-table MT20" width="100%">
						<tr>
							<th>费用项目</th>
							<th>金额</th>
						</tr>
						<tr v-for="(item,index) in data.referenceInfo.technicalServiceFeeList" :key="index">
							<td>{{item.name}}</td>
							<td>{{item.value}}</td>
						</tr>
					</table>
				</div><!-- 

				<div class="group MT20">
					<div class="page-group-title"><span>结款信息</span></div>
					<SettlementEdit v-if="drawerShow" ref="settlementEdit" :formData.sync="data"
						:btnLoading.sync="btnLoading"></SettlementEdit>
				</div> -->
			</template>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取 消</el-button>
			<!-- <el-button type="primary"
				v-if=" showdata && showdata.isBalance == 1 && showdata && showdata.isApplySettlement == 1 "
				:loading="rejectLoading" @click="reject()">驳回结款申请</el-button>
			<el-button type="primary" @click="onSubmit()" :loading="btnLoading"
				:disabled="data && !data.receivablesInfo ? true : false">提 交</el-button> -->
			<el-button type="primary" :loading="loadbtnLoading" @click="load()">下载结算单</el-button>
		</div>
	</el-drawer>
</template>

<script>
	// import SettlementEdit from './settlementEdit';
	import {
		downloadFileTmp
	} from '@/assets/js/commonApi.js';
	export default {
		components: {
			
		},
		data() {
			return {
				drawerShow: false,
				dataLoading: false,
				btnLoading: false,
				loadbtnLoading: false,
				rejectLoading: false,
				id: '',
				data: null,
				showdata: null
			}
		},
		methods: {
			close() {
				if (this.$refs.formData) this.$refs.formData.resetFields();
				this.data = null;
				this.drawerShow = false;
			},
			show(data) {
				this.showdata = data || null;
				this.id = data.id || '';
				this.btnLoading = false;
				if (data.id) {
					this.getData();
				}
			},
			//获取详情
			getData() {
				this.dataLoading = true;
				this.$request({
						url: '/activityFinanceSettle/receivablesInfo',
						params: {
							id: this.id
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = {
								...result,
								playPic: result.playPic || [],
								fileList: result.playPic ? result.playPic.map(v => {
									return {
										url: v
									}
								}) : []
							};
							this.drawerShow = true;
						} else {
							this.$message.error(msg || "获取详情失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("获取详情失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},
			//申请驳回
			reject() {
				this.rejectLoading = true
				this.$request({
						url: '/activityFinanceSettle/dismiss',
						params: {
							id: this.id
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1) {
							this.$message.success("操作成功");
							this.rejectLoading = false;
							this.close()
						} else {
							this.$message.error(msg || "操作失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("操作失败,请重试");
					})
					.finally(() => {
						this.rejectLoading = false;
					});
			},
			load() {
				this.loadbtnLoading = true
				let filePath;
				this.downLoading = true;
				this.$request({
					url: '/activityFinanceSettle/exportSettlement',
					method: 'POST',
					params: {
						activityId: this.id
					},
				}).then(res => {
					const {
						state,
						msg,
						result
					} = res.data;
					if (state == 1 && result) {
						filePath = result.url;
						downloadFileTmp(filePath, `${this.id}结算单.` + this.$utils.getFileType(filePath));
						this.loadbtnLoading = false;
					} else {
						this.loadbtnLoading = false;
						return this.$message.error(msg || '下载失败');
					}
				}).catch(() => {
					this.$message.error('请求错误');
				}).finally(() => {
					this.loadbtnLoading = false;
				});
			},
			onSubmit() {
				this.$refs.settlementEdit.onSubmit(() => {
					this.$emit('onUpdate');
					this.close();
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.info-table {
		th {
			min-width: 100px;
			text-align: right;
			white-space: nowrap;
			padding: 8px 0 8px 10px;
			text-align: left;
		}

		td {
			min-width: 100px;
			border-right: 1px solid #eee;
			padding: 8px 0 8px 10px;
			white-space: normal;
		}
	}
	.hand {
		cursor: pointer;
	}

	.ML5 {
		margin-left: 5px;
	}
</style>